document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".image-container");
    const modal = document.querySelector(".image-modal");
    const modalImage = document.getElementById("modal-image");
    const modalClose = document.querySelector(".modal-image-close");
    const modalOverlay = document.querySelector(".image-modal-overlay");
  
    let scrollPosition = 0;
    const scrollSpeed = 1.2;
    let isScrolling = true;
    let animationFrameId;
  
    // 自动滚动函数
    function autoScroll() {
      if (!isScrolling) return;
  
      scrollPosition -= scrollSpeed;
  
      // 计算最大滚动距离
      const totalWidth = container.scrollWidth - container.clientWidth + 80;
  
      // 当滚动到末尾时，重置到初始位置
      if (Math.abs(scrollPosition) >= totalWidth) {
        scrollPosition = 0;
        container.style.transition = "none";
        container.style.transform = `translateX(${scrollPosition}px)`;
        // 强制重绘
        container.offsetHeight;
        container.style.transition = "transform 0.3s ease";
      } else {
        container.style.transform = `translateX(${scrollPosition}px)`;
      }
  
      animationFrameId = requestAnimationFrame(autoScroll);
    }
  
    function startScroll() {
      isScrolling = true;
      autoScroll();
    }
  
    function stopScroll() {
      isScrolling = false;
      cancelAnimationFrame(animationFrameId);
    }
  
    // 启动自动滚动
    startScroll();
  

    // 鼠标进入容器时停止滚动
    container.addEventListener("mouseenter", stopScroll);
  
    // 鼠标离开容器时恢复滚动
    container.addEventListener("mouseleave", startScroll);

    // 触摸事件处理
    let startX = 0;
    let currentX = 0;

    container.addEventListener("touchstart", (e) => {
        stopScroll();
        startX = e.touches[0].clientX;
        currentX = startX;
    });

    // 触摸移动时手动滚动
    container.addEventListener("touchmove", (e) => {
        if (!startX) return;
        const x = e.touches[0].clientX;
        const diff = x - currentX;
        currentX = x;
        scrollPosition += diff;
        container.style.transform = `translateX(${scrollPosition}px)`;
    });

    // 触摸结束时恢复自动滚动
    container.addEventListener("touchend", () => {
        currentX = null;
        // 检查是否需要重置位置
        if (scrollPosition >= 0) {
            scrollPosition = -container.scrollWidth + container.clientWidth;
            container.style.transform = `translateX(${scrollPosition}px)`;
        }
        startScroll();
    });
  
    // 点击图片放大查看
    document.querySelectorAll(".image-wrapper").forEach((wrapper) => {
      wrapper.addEventListener("click", () => {
        // stopScroll();
  
        const img = wrapper.querySelector("img");
        // const title = wrapper.querySelector(".image-title").textContent;
  
        modalImage.src = img.src;
        // modal.querySelector(".image-title").textContent = title;
        modal.style.display = "block";
        document.body.style.overflow = "hidden";
      });
    });
  
    // 关闭模态框时恢复滚动
    modalClose.addEventListener("click", () => {
      modal.style.display = "none";
      document.body.style.overflow = "";
    //   startScroll();
    });
  
    modalOverlay.addEventListener("click", () => {
      modal.style.display = "none";
      document.body.style.overflow = "";
    //   startScroll();
    });
  
    // ESC键关闭模态框
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && modal.style.display === "block") {
        modal.style.display = "none";
        document.body.style.overflow = "";
        // startScroll();
      }
    });
  
    // 页面不可见时停止滚动
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) {
        stopScroll();
      } else {
        startScroll();
      }
    });
  
    // 右轮播相关代码
    const containerRight = document.querySelector(".image-container-right");
    if (containerRight) {
        let scrollPositionRight = -containerRight.scrollWidth + containerRight.clientWidth - 180;
        const scrollSpeedRight = 1.2;
        let isScrollingRight = true;
        let animationFrameIdRight;
  
        // 初始化位置
        containerRight.style.transform = `translateX(${scrollPositionRight}px)`;
  
        // 自动向右滚动函数
        function autoScrollRight() {
            if (!isScrollingRight) return;
  
            scrollPositionRight += scrollSpeedRight; // 向右滚动
  
            // 当滚动到最右侧时，重置到最左侧
            if (scrollPositionRight >= 40) {
                scrollPositionRight = -containerRight.scrollWidth + containerRight.clientWidth;
                containerRight.style.transition = "none";
                containerRight.style.transform = `translateX(${scrollPositionRight}px)`;
                // 强制重绘
                containerRight.offsetHeight;
                containerRight.style.transition = "transform 0.3s ease";
            } else {
                containerRight.style.transform = `translateX(${scrollPositionRight}px)`;
            }
  
            animationFrameIdRight = requestAnimationFrame(autoScrollRight);
        }
  
        function startScrollRight() {
            isScrollingRight = true;
            autoScrollRight();
        }
  
        function stopScrollRight() {
            isScrollingRight = false;
            cancelAnimationFrame(animationFrameIdRight);
        }
  
        // 启动右轮播自动滚动
        startScrollRight();
  
        // 鼠标进入容器时停止滚动
        containerRight.addEventListener("mouseenter", stopScrollRight);
  
        // 鼠标离开容器时恢复滚动
        containerRight.addEventListener("mouseleave", startScrollRight);
  
        // 触摸事件处理
        let startXRight = 0;
        let currentXRight = 0;
  
        containerRight.addEventListener("touchstart", (e) => {
            stopScrollRight();
            startXRight = e.touches[0].clientX;
            currentXRight = startXRight;
        });
  
        containerRight.addEventListener("touchmove", (e) => {
            if (!currentXRight) return;
            const x = e.touches[0].clientX;
            const diff = x - currentXRight;
            currentXRight = x;
            scrollPositionRight += diff;
            containerRight.style.transform = `translateX(${scrollPositionRight}px)`;
        });
  
        containerRight.addEventListener("touchend", () => {
            currentXRight = null;
            // 检查是否需要重置位置
            if (scrollPositionRight >= 0) {
                scrollPositionRight = -containerRight.scrollWidth + containerRight.clientWidth;
                containerRight.style.transform = `translateX(${scrollPositionRight}px)`;
            }
            startScrollRight();
        });
  
        // 页面不可见时停止滚动
        document.addEventListener("visibilitychange", () => {
            if (document.hidden) {
                stopScrollRight();
            } else {
                startScrollRight();
            }
        });
    }
  });
  